<template>
	<Dialog v-bind:value="value" @input="$emit('input', $event)"
					:title="title" hide-buttons width="max-content" min-width="550px"
					@cancel="$emit('input', false)"
	>
		<span class="text-body-1">Sitetypes für das Deployment wählen</span>
		<div>
			<div v-for="(sitetype, i) in sitetypeConfigs" :key="'sitetype_'+i">
				<v-checkbox
					v-model="selectedSitetypes"
					:color="ada.darkGrey"
					multiple
					:value="sitetype.sitetypeId"
					:disabled="sitetype.disabled"
					hide-details
				>
					<template #label>
						<div style="position: relative; width: 100%">
							<div>
								{{ sitetype.name }}
								<span class="pl-2" style="opacity: 0.7">- {{ sitetype.sitetypeId }}.json</span>
								<v-chip v-if="selectedSitetype && (sitetype.sitetypeId === selectedSitetype.SitetypeId)"
												class="font-weight-bold ml-2" dark label small :color="ada.darkGrey">
									current
								</v-chip>
								<v-progress-circular v-if="sitetypeConfigs.loading || getConfig(sitetype).loading"
																		 class="ml-4" :size="16" :width="2"
																		 :color="ada.pink" indeterminate>
								</v-progress-circular>
								<div class="d-inline-block ml-3"
										 v-if="!getConfig(sitetype).loading && typeof getConfig(sitetype).request !== 'undefined'">
									<v-icon color="green" v-if="getConfig(sitetype).request === 'success'">mdi-check
									</v-icon>
									<v-icon color="red" v-if="getConfig(sitetype).request === 'error'">mdi-close
									</v-icon>
								</div>
							</div>
						</div>
					</template>
				</v-checkbox>
				<v-expand-transition>
					<div class="d-flex flex-row hintWrapper">
                        <span
													v-if="(sitetype.hint && sitetype.hint !== '') || (type !== 'copy' && selectedSitetypes.find( x => x === sitetype.sitetypeId))"
													class="hint">
													{{ sitetype.hint }}
                        </span>
						<div class="pl-1" style="position:relative; top:-2px;">
							<TooltipIcon v-if="(sitetype.tooltip && sitetype.tooltip !== '')"
													 :tooltip="sitetype.tooltip" xsmall color="orange">mdi-information
							</TooltipIcon>
						</div>
					</div>
				</v-expand-transition>
			</div>
		</div>
		<v-divider class="my-6"></v-divider>
		<Textarea v-model="description" label="Deploy Beschreibung" rows="3"></Textarea>
		<div class="d-flex justify-end mt-4">
			<div v-if="type === 'copy'">
				<Button text :color="ada.blue" @click="submit('stage')"
								:disabled="typeof configs.find(x => x.loading === true) !== 'undefined'">
					Copy:Stage
				</Button>
				<Button text :color="ada.pink" @click="submit('live')"
								:disabled="typeof configs.find(x => x.loading === true) !== 'undefined'">
					Copy:Live
				</Button>
			</div>
			<Button v-else text :color="type === 'live' ? ada.pink : ada.blue" @click="submit(type)"
							:disabled="typeof configs.find(x => x.loading === true) !== 'undefined'">
				Deploy:{{ type }}
			</Button>
		</div>
	</Dialog>
</template>

<script>
import Dialog from "../../components/Dialog";
import Button from "../../components/buttons/Button";
import ada from "../../scss/ada_colors.scss";
import Utils from "../../scripts/Utils";
import Textarea from "../../components/Inputs/Textarea";
import TooltipIcon from "../../components/TooltipIcon";

export default {
	name: "JsonSaveDialog",
	props: ['value', 'type', 'configs', 'selectedEditData'], //type: live, stage, copy
	components: {TooltipIcon, Textarea, Button, Dialog},
	data: () => {
		return {
			ada,
			selectedSitetypes: [],
			sitetypeConfigs: [],
			description: null,
		}
	},
	mounted() {
		this.init();
	},
	computed: {
		vuexState() {
			return this.$store.state.editor;
		},
		title() {
			return this.type === 'copy' ? 'Template kopieren' : ((this.type ? Utils.capitalize(this.type) + ' ' : '') + 'Deployment');
		},
		sitetypes() {
			return this.vuexState.siteDetails ? this.vuexState.siteDetails.Types : [];
		},
		selectedSitetype() {
			return this.vuexState.selectedSitetype;
		},
		currentFinalJsonKey() {
			return this.vuexState.finalTemplateKey;
		},
		currentFinalJson() {
			return this.vuexState.finalJson;
		},
	},
	methods: {
		init() {
			this.sitetypeConfigs = [{
				name: this.selectedSitetype ? this.selectedSitetype.Name : '',
				loading: false,
				sitetypeId: this.selectedSitetype ? this.selectedSitetype.SitetypeId : null,
				live_json: this.vuexState.jsonContent_live,
				stage_json: this.vuexState.jsonContent_stage,
				new_json: this.currentFinalJson,
				key: this.currentFinalJsonKey,
				disabled: false,
				hint: '',
				tooltip: '',
			}];
			this.selectedSitetypes = this.type !== 'copy' && this.selectedSitetype ? [this.selectedSitetype.SitetypeId] : [];
			if (this.configs.length !== 0) {
				this.configs.forEach((config) => {
					config.loading = false;
					config.request = null;
				})
			}
			if (this.vuexState.jsonContent_live || this.vuexState.jsonContent_stage) this.initSitetypeConfig();
			let descParts = [];
			if (this.selectedEditData) {
				if (this.selectedEditData.selectedType && this.selectedEditData.selectedType !== 'default') {
					descParts.push(this.selectedEditData.selectedType);
				}
				if (this.selectedEditData.selectedTeasertypes && this.selectedEditData.selectedTeasertypes.length > 0) {
					descParts.push(this.selectedEditData.selectedTeasertypes.map(x => x.name).join(' '));
				}
			}
			this.description = descParts.join(' | ') + (this.type === 'copy' ? ' kopiert' : ' bearbeitet');
		},
		submit(type, copyAction = false) {
			if (copyAction) this.generateNewJson(type);
			let ret = [];
			this.selectedSitetypes.forEach((id) => {
				let config = this.sitetypeConfigs.find(x => x.sitetypeId === id);
				if (config) ret.push(config);
			});
			this.$emit('submit', type, ret, this.description);
		},
		initSitetypeConfig() {
			let types = JSON.parse(JSON.stringify(this.sitetypes));
			this.sitetypeConfigs.forEach((json) => {
				if (types.findIndex(x => x.SitetypeId === json.sitetypeId) !== -1) {
					types.splice(types.findIndex(x => x.SitetypeId === json.sitetypeId), 1);
				}
			})
			types.forEach((sitetype) => {
				this.sitetypeConfigs.push({
					name: sitetype.Name,
					loading: false,
					sitetypeId: sitetype.SitetypeId,
					new_json: null,
					key: null,
					disabled: false,
					hint: '',
					tooltip: '',
				})
			});
			this.sitetypeConfigs.sort(function (a, b) {
					if (a.name < b.name) {
						return -1;
					}
					if (a.name > b.name) {
						return 1;
					}
					return 0;
				}
			);
			this.fetchAllJsons();
		},
		generateNewJson(type) {
			this.sitetypeConfigs.forEach((config) => {
				config.key = Utils.getFinalJsonKey(this.currentFinalJsonKey, config[type + '_json']);
				config.new_json = JSON.parse(JSON.stringify(config[type + '_json']));
				config.new_json[config.key] = this.currentFinalJson[this.currentFinalJsonKey];
			})
		},
		fetchAllJsons() {
			this.sitetypeConfigs.forEach((sitetype) => {
				if (this.selectedSitetype.SitetypeId !== sitetype.sitetypeId) this.fetchJson(sitetype.sitetypeId);
			})
		},
		async fetchJson(sitetypeId) {
			if (this.type) {
				//fetch cached_live, live, preview JSONs
				this.sitetypeConfigs[this.sitetypeConfigs.findIndex(x => x.sitetypeId === sitetypeId)].loading = true;
				let data = await this.$store.dispatch('editor/fetchJSON', {
					id: sitetypeId,
					return: true
				});

				//store jsons in matching sitetypeConfig
				const validResults = data.filter(result => !(result instanceof Error));
				let index = this.sitetypeConfigs.findIndex(x => x.sitetypeId === sitetypeId);
				let live_res = validResults.find(x => x.config.url.indexOf(this.vuexState.baseDomain_live_cache) !== -1 || x.config.url.indexOf(this.vuexState.baseDomain_live) !== -1);
				let stage_res = validResults.find(x => x.config.url.indexOf(this.vuexState.baseDomain_stage) !== -1);
				this.sitetypeConfigs[index].live_json = live_res ? live_res.data : {};
				this.sitetypeConfigs[index].stage_json = stage_res ? stage_res.data : {};
				this.sitetypeConfigs[index].key = Utils.getFinalJsonKey(this.currentFinalJsonKey, this.sitetypeConfigs[index][this.type + '_json']);

				if (this.type !== 'copy') {
					this.sitetypeConfigs[index].new_json = JSON.parse(JSON.stringify(this.sitetypeConfigs[index][this.type + '_json']));
					this.sitetypeConfigs[index].new_json[this.sitetypeConfigs[index].key] = this.currentFinalJson[this.currentFinalJsonKey];
					if (typeof this.sitetypeConfigs[index][this.type + '_json'][this.sitetypeConfigs[index].key] === "undefined") {
						this.sitetypeConfigs[index].hint = 'Kein passendes Template gefunden. Mit Deploy wird dieses Template rüberkopiert.';
					}
				}
				this.checkDuplicates(index);
				this.sitetypeConfigs[index].loading = false;
			}
		},
		checkDuplicates(index) {
			let duplicatesLive = Utils.checkDuplicateKeys(this.sitetypeConfigs[index].key, this.sitetypeConfigs[index].live_json, this.sitetypeConfigs[index].key);
			let duplicatesStage = Utils.checkDuplicateKeys(this.sitetypeConfigs[index].key, this.sitetypeConfigs[index].stage_json, this.sitetypeConfigs[index].key);
			if (duplicatesLive.length !== 0 || duplicatesStage.length !== 0) {
				this.sitetypeConfigs[index].hint = 'Duplikat Warnung auf ' + (duplicatesLive.length !== 0 ? '<span class="ada_pink">[ LIVE ]</span>' : '') +
					(duplicatesLive.length !== 0 ? ' und ' : '') + (duplicatesStage.length !== 0 ? '<span class="ada_blue">[ STAGE ]</span>' : '') +
					'. Bitte vorher Template löschen.';
				this.sitetypeConfigs[index].tooltip = '<div style="padding: 5px 0;">Gefundene Duplikate:</div>'
				/*color: $ada_pink #D70364;
				color: $ada_blue #00B6ED;*/
				this.sitetypeConfigs[index].tooltip += duplicatesLive.length !== 0 ? ('<div style="padding: 5px 0;"><span style="padding: 5px 8px; background:#00B6ED; color:#fff; border-radius: 4px; margin-right:10px; font-size:12px; font-weight: bold;">LIVE</span> ' + duplicatesLive.join(', ') + (duplicatesStage.length !== 0 ? '</div>' : '</div>')) : '';
				this.sitetypeConfigs[index].tooltip += duplicatesStage.length !== 0 ? '<div style="padding: 5px 0;"><span style="padding: 5px 8px; background:#00B6ED; color:#fff; border-radius: 4px; margin-right:10px; font-size:12px; font-weight: bold;">STAGE</span> ' + duplicatesStage.join(', ') + '</div>' : '';
				this.sitetypeConfigs[index].disabled = true;
			}
		},
		getConfig(sitetype) {
			if (this.configs.find(x => x.sitetypeId === sitetype.sitetypeId)) {
				return this.configs.find(x => x.sitetypeId === sitetype.sitetypeId)
			} else {
				return {loading: false};
			}
		},
	},
	watch: {
		selectedSitetypes() {
			if (this.type !== 'copy' && this.selectedSitetype && !this.selectedSitetypes.includes(this.selectedSitetype.SitetypeId)) {
				this.selectedSitetypes.push(this.selectedSitetype.SitetypeId);
			}
		},
		value() {
			if (this.value) this.init();
		}
	}
}
</script>

<style lang="scss" scoped>

.hintWrapper {
	padding-left: 33px;
}

.hint {
	font-size: 12px;
	color: #ff9800;

}

::v-deep .ada_pink {
	color: $ada_pink;
}

::v-deep .ada_blue {
	color: $ada_blue;
}
</style>